import React, { useCallback } from 'react';
import Link from '../../components/link';

import type { heroEvents } from '../../shared/tracking';
import { Column } from '../../styled-components/components/Columns';

const internalUrl = (s: string) => s.startsWith('/');

type HERO_EVENT_TYPES = keyof typeof heroEvents;

interface TrackPayload {
  callToActionTitle?: string;
  callToActionUrl?: string;
}

interface CtaButtonProps {
  callToActionTitle?: string;
  callToActionUrl?: string;
  ctaModifiers?: string;
  eventType: HERO_EVENT_TYPES;
  trackDefaultEvent: (eventType: string, payload: TrackPayload) => void;
}

const CtaButton = ({
  callToActionTitle,
  callToActionUrl,
  ctaModifiers,
  eventType,
  trackDefaultEvent,
}: CtaButtonProps) => {
  const track = useCallback(
    () =>
      trackDefaultEvent(eventType, {
        callToActionTitle,
        callToActionUrl,
      }),
    [callToActionTitle, callToActionUrl, eventType, trackDefaultEvent],
  );

  if (!callToActionTitle || !callToActionUrl) {
    return null;
  }

  const isInternal = internalUrl(callToActionUrl);

  return (
    <Column $noShrink>
      {isInternal ? (
        <Link
          to={callToActionUrl}
          onClick={track}
          data-wx-button={ctaModifiers}
          title={callToActionTitle}
        >
          <div className="button-text">{callToActionTitle}</div>
        </Link>
      ) : (
        <a
          href={callToActionUrl}
          title={callToActionTitle}
          onClick={track}
          data-wx-button={ctaModifiers}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="button-text">{callToActionTitle}</div>
        </a>
      )}
    </Column>
  );
};

export default CtaButton;
